import React, { forwardRef, useImperativeHandle, useState } from 'react';

import {
  Text,
  Image,
  Modal,
  ModalBody,
  ModalContent,
  ModalOverlay,
  ModalCloseButton,
  useDisclosure,
} from '@chakra-ui/react';

const Preview = forwardRef((_, ref) => {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const [fileName, setFileName] = useState<string>('');

  useImperativeHandle(
    ref,
    () => ({
      onOpen: (fileName: string) => {
        setFileName(fileName);

        onOpen();
      },
    }),
    [],
  );

  const imageSrc = `https://rturn${
    process.env.REACT_APP_ENVIRONMENT === 'dev' ? '-dev' : ''
  }.s3.amazonaws.com/${fileName}`;

  return (
    <Modal
      size="xl"
      isCentered
      isOpen={isOpen}
      onClose={onClose}
      closeOnOverlayClick={false}>
      <ModalOverlay />
      <ModalContent>
        <ModalCloseButton />
        <ModalBody px="20px" py="40px">
          <Text mb="20px" fontSize="14px" textAlign="center">
            {fileName || ''}
          </Text>
          <Image h="300px" w="100%" src={imageSrc} objectFit="contain" />
        </ModalBody>
      </ModalContent>
    </Modal>
  );
});

export default Preview;
